import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { TerminationReason } from '../entities/terminationReason';

@Injectable()
export class TerminationReasonService extends BaseCrudService<TerminationReason> {

  public uri = '/api/terminationReason/';
  
  constructor(injector: Injector) {
      super(injector);
     //console.log('Instance TerminationReasonService');
  }

  buildSentence(entity?: TerminationReason, event?: LazyLoadEvent): HttpParams {
    this.httpParams = new HttpParams();
      if (entity) {
          let query = entity.code ? 'code'
              + QueryOperator.Contain + entity.code
              + QueryOperator.Split : QueryOperator.Empty;
          query = query.concat(
              entity.name ? 'name'
              + QueryOperator.Contain + entity.name
              + QueryOperator.Split : QueryOperator.Empty
          );
          if (entity.executingUnit && entity.executingUnit.id) {
            query = query.concat(
              `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
            );
          }
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
      }

      if (event) {
          const page = ((event.first + event.rows) / event.rows - 1 ).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
      }

      this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'code');
      return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/termination-reason.service.ts